/**
 * Lit TOUTES les lignes d'une requête, page par page.
 *
 * ⚠️ Supabase plafonne une réponse à 1 000 lignes (réglage `max_rows` par
 * défaut) et ne signale RIEN quand il tronque : la 1 001e commande disparaît
 * simplement. Pour la comptabilité, c'est un chiffre d'affaires faux sans le
 * moindre avertissement. La requête doit avoir un tri STABLE (terminer par une
 * colonne unique, `id`), sinon une ligne peut passer d'une page à l'autre.
 */
export async function toutesLesLignes<T>(
  page: (de: number, a: number) => PromiseLike<{ data: T[] | null; error: unknown }>,
  taille = 1000,
): Promise<T[]> {
  const tout: T[] = []
  for (let de = 0; ; de += taille) {
    const { data, error } = await page(de, de + taille - 1)
    if (error) throw error
    const lot = data ?? []
    tout.push(...lot)
    if (lot.length < taille) return tout
  }
}
